import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { boardEntryPoint } from '@jira/spa-apps__board/src/boardEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { JIRA_BOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { jiraBusinessBoardRoute } from '@jira/router-routes__business-board-routes/src/jiraBusinessBoardRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { jiraBusinessBoardResources } from './common/jiraBusinessBoardResources.tsx';

const boardPageEntryPoint = createPageEntryPoint({
	main: boardEntryPoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});
export const jiraBusinessBoardRouteEntry: Route = createEntry(jiraBusinessBoardRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.jwm-board',

	layout: businessProjectLayout,

	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: jiraBusinessBoardResources(),

	entryPoint: () => boardPageEntryPoint,

	meta: {
		capability: JIRA_BOARD,
	},

	supportsPreviewPanel: true,
	supportsProjectTheme: 'full',
	isHydrateRootEnabled: true,

	bifrost: {
		bifrostGroup: 'backlog-and-board',
	},
}));
